//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAll, deleteCompany } from '../../api/company';
import CreateCompanyModal from './components/create-company-modal';

export default {
    name: 'index',
    components: { CreateCompanyModal },
    data() {
        return {
            loading: false,

            list: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            searchInput: {},
            columns: [
                {
                    type: 'index',
                    align: 'center',
                    maxWidth: 66
                },
                {
                    title: '公司名称',
                    key: 'name',
                    align: 'center'
                },
                {
                    title: '公司电话',
                    key: 'phone',
                    align: 'center'
                },
                {
                    title: '公司地址',
                    key: 'address',
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center'
                }
            ],
            createCompanyModal: false
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(size) {
            this.pageSize = size;
            this.getPage();
        },
        getPage() {
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.searchInput.maxResultCount = this.pageSize;
            this.loading = true;
            getAll(this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        edit(row) {
            this.$refs.createCompanyRef.update(row);
            this.createCompanyModal = true;
        },
        handleDel(row) {
            // this.$Modal.confirm({
            //         title: this.L('Tips'),
            //         content: '确认删除吗？',
            //         okText: this.L('Yes'),
            //         cancelText: this.L('No'),
            //         onOk: async () => {

            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    this.delete(row.id);
                }
            });
        },
        delete(id) {
            const vm = this;
            deleteCompany(id).then(() => {
                this.$Notice.success({
                    duration: 3,
                    title: '删除成功'
                });
                vm.getPage();
            }).finally(() => {

            });
        }
    },
    created() {
        this.getPage();
    }
};
